<template>
  <div :style="style" class="mobile-nav fixed w-full">
    <router-link to="/">
      <i class="fas fa-home" />
    </router-link>
    <router-link to="/feed">
      <!--      <i class="fas fa-bullseye" />-->
      <i class="fas fa-map-marker" />
    </router-link>
    <router-link to="/">
      <i class="far fa-plus-square" />
    </router-link>
    <router-link v-if="username" :to="{ name: 'logout' }">
      <i class="fas fa-user-circle" />
    </router-link>
    <router-link v-else :to="{ name: 'login' }">
      <i class="fas fa-sign-in-alt" />
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { NS_USER } from "@/store/constants";

export default {
  props: {
    height: {
      type: Number,
      default: 30
    }
  },

  computed: {
    style() {
      return `height:${this.height}px;`;
    },

    ...mapState({
      username(state) {
        return state[NS_USER].username;
      }
    })
  }
};
</script>

<style scoped>
.w-full {
  width: 100%;
}

.mobile-nav {
  background: black;
  bottom: 0;
  z-index: 2;
  min-height: 45px;
  display: flex;
  justify-content: space-around;
}

.mobile-nav a {
  color: white;
  align-self: center;
  padding: 10px 20px;
}
</style>
